import getDay from '@teetsh/app/src/utils/time/getDay';

export function doesDayBelongToWorkingDays(
  date: Date,
  workingDays: number[],
): boolean {
  return workingDays.map(d => (d + 1) % 7).includes(getDay(date));
}
